export const getAllRequest = "Requirements";
export const getAllTemplates = "getAllJD";
export const getAllstatus = "GetStatusList";
export const getAllApplicationNames = "GroupsName?name=Applications";
export const getEvaluationByDesignation = "GroupsName?name=InterviewEvaluation";
export const getOverallAssessmentByDesignation =
  "GroupsName?name=CandidateStatus";
export const getRejectReasonByDesignation = "GroupsName?name=Rejected";
export const getInterviews = "GroupsName?name=Interviews";
export const getAllPriority = "GroupsName?name=Priority";
export const getAllManagerList = "GetManagerList";
export const getAllEmployee = "Get-AllEmployees";
export const getAllProject = "getAllProjectList";
export const addManageRequest = "Requirements";
export const getAllAssessmentImportance =
  "GroupsName?name=AssessmentImportance";
export const getAllAssessmentType = "GroupsName?name=AssessmentType";
export const getJDTemplateById = "JDs";
export const patchJDTemplateById = "JD";
export const getRequestById = "Requirements";
export const updateRequestById = "Requirements";
export const deleteRequestById = "Requirements/delete";
export const deleteCallingCandidateDetail = "deleteCallingCandidateDetail";
export const addRecruiters = "AssignRecruiters";
export const getRecruitersByRequirementId = "AssignRecruiters-Requirement";
export const rejectRequest = "rejectRequest";
export const cancelRequest = "cancelRequest";

export const getPageinationAllTechnology = "Technologys";
export const DeleteSkill = "DeleteSkills";
export const PostSkill = "Skills";
export const UpdateSkill = "Skills";

export const DeleteProject = "Projects";
export const PostProject = "Projects";
export const UpdateProject = "Projects";

export const DeleteRole = "Roles";
export const PostRole = "Roles";
export const UpdateRole = "Roles";

export const PostCallingCandidateDetail = "CallingCandidateDetail";

export const getAllJDListData = "JDs";
export const approveRequest = "approveRequest";
export const getAllWorkMode = "GroupsName?name=ModeOfWork";
export const getRequirementList = "RequirementListWithTitleAndId";
export const getInterviewTypeAndRounds = "InterviewTypeRound";
export const getAllScheduleTypes = "ScheduleTypes";
export const addJDTemplate = "JDs";
export const getInterviewerDetails = "InterviewerData";
export const getRequirementMappingList = "RequirementMapping";

export const postInterviewScheduleDetails = "Schedules";
export const getleadTime = "LeadTimes";
export const PatchLeadTimeData = "LeadTimes";
export const getTechnologyListWithTitleAndId = "technologyListWithTitleAndId";
export const getAllDegree = "GetAllDegree";
export const login = "user/login";
export const logout = "logout";

// login API route for synoverge
export const synoLogin = "user/userLogin";

export const getUser = "Employee/me";
export const viewRequest = "viewRequest";
export const getAllRounds = "AllRounds";
export const getRoundCount = "Schedule-CandidatesRoundCount";
export const postInterviewPanelDetails = "InterviewPanel";
export const updateInterviewPanelDetails = "InterviewPanelDetails";
export const getInterviewPanelWithPagination = "InterviewPanelWithPagination";
export const getFeedbackData = "InterviewFeedback";
export const getInterviewFeedbackData = "getInterviewFeedback";
export const getAllCandidateDetails = "CandidateAllDetails";
export const getCandidateDetailsById = "getCandidatesById";
export const getInterviewHistoryByCandidateId = "Schedule-Candidate";
export const getAllInterviewerList = "GetAllInterviewer";
export const getCancelReasons = "GroupDetail-groups";
export const getAllCities = "getAllCities";
//master api routes

// ------------------- Candidate routes -------------------
export const getAllCandidate = "Candidates";
export const getAllCandidateListName = "GetAllCandidates";
export const GetAllCandidateEmailList = "GetAllCandidateEmailList";
export const getCandidateDetailById = "getCandidates";
export const getCandidateBasicDetails = "CandidateBasicDetails";
export const getCallingCandidateData = "getCallingCandidateData";
export const getCandidateEducationalDetails = "CandidateEducationalDetails";
export const getCandidateOtherDetails = "CandidatesOtherDetails";
export const getCandidateProfessionalDetails = "CandidatesProfessionalDetails";
export const addCandidateBasicDetails = "AddCandidateBasicDetails";
export const addCandidateEducationalDetails = "AddCandidateEducationalDetails";
export const addCandidateOtherDetails = "CandidateOtherDetails";
export const addCandidateProfessionalDetails = "CandidateProfessionalDetails";
export const deleteCandidate = "deleteCandidate";
export const getCandidateInterviewCount = "getCandidateInterviewCount";
export const getCandidateInterviewLogs = "getCandidateInterviewLogs";
export const postFinalizeCandidate = "FinalizeCandidate";
export const getReferralData = "CandidatesReferral";
export const getCandidateStatusLogById = "CandidateRequirementStatusLog";
export const getCallingCandidateDetail =
  "getCallingCandidateDetailWithPagination";
export const getCandidateCallingDetail = "getCandidateCallingDetail";
export const getAllCallingCandidateListName = "GetAllCallingCandidates";
export const GetAllCallingCandidateEmailList =
  "GetAllCallingCandidateEmailList";
export const getCallingCandidateStatus =
  "GroupsName?name=CallingCandidateStatus";
export const getCallingCandidateReasonForChange =
  "GroupsName?name=CandidateReasonForChange";
export const ConvertCallingCandidateToCandidate =
  "convertCallingCandidateIntoCandidate";
export const GetCandidateListWithCv = "GetCandidateListWithCv";
export const filterCallingCandidateByName = "filterCallingCandidateByName";

// ------------------- External candidate routes -------------------
export const getCandidateBasicDetailsExternal = "CandidateBasicDetailsExternal";
export const addCandidateBasicDetailsExternal =
  "AddCandidateBasicDetailsExternal";
export const getAllDegreeExternal = "GetAllDegreeExternal";
export const getCandidateEducationalDetailsExternal =
  "CandidateEducationalDetailsExternal";
export const addCandidateEducationalDetailsExternal =
  "AddCandidateEducationalDetailsExternal";
export const getAllCitiesExternal = "getAllCitiesExternal";
export const getTechnologyListWithTitleAndIdExternal =
  "technologyListWithTitleAndIdExternal";
export const getCandidateProfessionalDetailsExternal =
  "CandidatesProfessionalDetailsExternal";
export const addCandidateProfessionalDetailsExternal =
  "CandidateProfessionalDetailsExternal";

// ********************master api routes***********************
// ------------------- Sources routes -------------------
export const getSources = "GetSourcesWithPagination";
export const PostSource = "CreateSources";
export const UpdateSource = "Sources";
export const DeleteSource = "DeleteSource";
export const getRecruiterData = "RecruiterList";

// ------------------- Technology routes -------------------
export const getAllTechnology = "TechnologyWithPaginationBE";
export const postAddTechnology = "CreateTechnology";
export const UpdateTechnology = "UpdateTechnology";
export const DeleteTechnology = "DeleteTechnology";
export const getTechnologies = "Technologies";

// -------------------- General API(S)---------------------
export const getAllSkills = "GetSkillList";
export const getAllProjects = "GetAllProjects";
export const getAllRoles = "getAllRoles";
export const getMasterEmployeeList = "GetEmployeeList";
export const getStatusByDescription = "getStatusByDescription";
export const getRecruitmentReport = "RecruitmentReport";

export const getSkillByCandidateRequirementTd =
  "getSkillByScheduleIdCandidateId";
export const postAssessmentResult = "InterviewFeedback";
export const updateUserSearchCriteria = "UserSearchCriterias";
export const getUserSearchCriteria = "UserSearchCriteriaByPathname";
export const getExperiencedEmployee = "GetExperiencedEmployee";
export const PostLeadTimes = "LeadTimes";
export const Schedules = "Schedules";
export const getCandidateDesignation = "CandidateDesignation";
export const deleteInterviewPanel = "DeleteInterviewPanel";
export const getCandidateStatusList = "GetCandidateStatusList";
export const getScheduledata = "SchedulesById";
export const updateDelete = "Schedules";
export const getCancelAndRescheduleOpt = "IaGroupDetail-groups";
export const NewRescheduledInterview = "RescheduleSchedules";
export const getSkillListData = "Skills";
export const getProjectListData = "Projects";
export const getRoleListData = "Roles";
export const getLeadDay = "GetAllLeadTime";
export const getReferralSources = "AllSources";
export const getAllDropoutReason = "GroupsName?name=Dropout Reason";
export const getConfigurationPages = "GroupsName?name=Configuration";
export const getFrequencyData = "GroupsName?name=FrequencyFinalizeCandidate";
export const CandidateRequestHistory = "CandidateRequestHistory";

// <------------------Role Service Apis------------------>
export const getApplicationRoles = "getApplicationRolesDetail";
export const getRolesWithoutCurrentRole = "getRoles";
export const getApplicationPagePermissions =
  "getApplicationPagePermissionsDetail";
export const postApplicationRoleBasePageAccessDetail =
  "postApplicationRoleBasePageAccessDetail";
export const getApplicationRoleBasePageAccessDetail =
  "getApplicationRoleBasePageAccessDetail";
export const AddEducationDegree = "CreateEducationalDegree";
export const UpdateEducationalDegree = "UpdateEducationDegree";
export const DeleteEducationDegree = "DeleteDegree";
export const getAllDegreeByPagination = "EducationWithPagination"; // i want to call this API in the BACKEND
export const getEmailEventsWithPagination = "EmailEventsWithPagination";
export const StatusForHREditRequest = "GetStatusforHReditRequest";
export const UpdateOrderBy = "UpdateOrderBy";
export const getPagePermissionList = "pagePermissionList";
export const getDataScopeList = "GroupsName?name=Data Scope";
export const getPageAccess = "PageAccess";
export const validateSystemAdminAndRecruiter =
  "validateSystemAdminAndRecruiter";

// <------------------Report Api------------------>
export const leadTimeReport = "leadTimeReport";
export const getOfferToJoiningReport = "OfferToJoiningReport";
export const getInterviewSummaryReport = "InterviewSummaryReport";
export const candidateresume = "Candidate-Resume";

// <-------------------------------- DashBoard Apis ---------------------------------->
export const getCardsDetail = "getDashboardCardsDetail";
export const getOfferedCandidateList = "getDashboardOfferedCandidateList";
export const getCriticalRequest = "getDashboardCriticalRequest";
export const getRecruiterAssigned = "getDashboardRecruiterAssigned";
export const getCandidateFinalization = "getDashboardCandidateFinalization";
export const getSourceClosure = "getDashboardSourceClosure";
export const getInterviewRoundProcess = "getDashboardInterviewRoundProcess";
export const getJobOpenings = "getDashboardJobOpenings";
export const getCallingCandidateList = "getDashboardCallingCandidateList";
export const getRecruiterCardsDetail = "getRecruiterDashboardCardsDetail";
export const getRecruiterOfferedCandidateList =
  "getRecruiterDashboardOfferedCandidateList";
export const getRecruiterCriticalRequest =
  "getRecruiterDashboardCriticalRequest";
export const getRecruiterCandidateFinalization =
  "getRecruiterDashboardCandidateFinalization";
export const getInterviewerCardsDetail = "getInterviewerDashboardCardsDetail";
export const getInterviewerOfferedCandidateList =
  "getInterviewerDashboardOfferedCandidateList";
export const getShortlistedCandidateSwimlane = "ShortlistCandidateSwimelane";

// <----------------------- User Apis ---------------------------->
export const getUserList = "Employees";
export const insertUser = "Employees";
export const getUserById = "Employees";
export const editUser = "Employees/update";
export const deleteUser = "Employees";
export const bulkEmployeeImport = "bulkCreateEmployee";

// signup routes

export const sendOtp = "user/send-otp";
export const resendOtp = "user/resend-otp";
export const verifyOtp = "user/verify-otp";
export const registerUser = "user/register-user";
export const termsAndPolicy = "user/termsAndPolicy";
export const inviteUser = "Employees/invite";

//AI service route
export const cvParsing = "resumeScreening";
export const addCandidateFromAi = "AddCandidateFromResumeScreening";
export const botInitializeExternal = "botInitializeExternal";
export const chatbotCompletionExternal = "chatbotCompletionExternal";
export const saveBotInterviewActivityExternal =
  "saveBotInterviewActivityExternal";
export const chatBotHistoryApi = "chatBotHistory";
export const BotInterviewhandelFailureExternal = "BotInterviewhandelFailureExternal";

// payment routes
export const createOrder = "payment/order";
export const createSubscription = "payment/subscription";
export const verifyOrder = "payment/verify";

// Plan routes
export const viewPlan = "plans/view";
export const viewPlanList = "plans/List";

// platform integration apis
export const createMeetingCredentials = "MeetingCredentials";
export const meetingCredentials = "MeetingCredentials";
export const updateMeetingCredentials = "updateMeetingCredentials";
export const deleteMeetingCredentials = "deleteMeetingCredentials";
export const credentialsByScheduleTypeId = "getMeetingCredentialsById";
export const verifyMeetingCredentials = "verifyMeetingCredentials";

// Auth Configuration apis
export const credentialsForOrganization = "credentialsForOrganization";
export const updateCredentials = "updateCredentials";

// Forgot password Route
export const forgotPassRoute = "forgot-password";
export const setForgotPassRoute = "set-password";
export const changePassRoute = "change-password";

// EmailConfig route
export const getEmailEvents = "EmailEvents";
export const getEmailEventById = "EmailEvent";
export const getEmailRecipientRoles = "EmailRecipientRoles";
export const updateEmailRecipient = "EmailRecipients";
export const getLetterEvents = "LetterEvents";
export const getLetterEventById = "LetterEvent";
export const updateLetterEvent = "LetterEvent";
export const createLetterEvent = "createLetterEvent";
export const deleteLetterEvent = "LetterEvent";
export const generateOfferLetter = "GenerateOfferLetter";
export const getCurrentRequirement = "getCurrentRequirement";
//candidate History Route
export const createCandidateHistory = "AddCandidateHistory";
export const CandidateAssociatedRequirements =
  "CandidateAssociatedRequirements";
export const getCandidateHistoryByRequirementId =
  "getCandidateHistoryByRequirementId";
export const getCandidateFinalizationHistoryById =
  "getCandidateFinalizationHistoryById";

//feedback form
export const getFeedbackQuestion = "getFeedbackQuestionExternal";
export const saveCandidateFeedback = "candidateFeedbackExternal";
export const fillFeedbackCandidateList = "fillFeedbackCandidateList";
export const viewCandidateFeedback = "candidateFeedbackView";

// cron-configuration
export const CronJobs = "CronJobs";
export const runCron = "runCron";

// designation apis
export const getAllDesignations = "GetAllDesignations";
export const getDesignationListData = "Designations";
export const DeleteDesignation = "Designations";
export const PostDesignation = "Designations";
export const UpdateDesignation = "Designations";

//licensing
export const getAllPlans = "productPlansDetails";
export const requestPlan = "requestPlan";

// send rejection mail to candidate
export const sendRejectionMail = "sendRejectionEmail";

export const getRequirementById = "getRequirementById";
export const reviseRequirement = "reviseRequirement";

// get organization auth type from sub-domain
export const organizationSubDomain = "organization-subdomain";

export const uploadVideoInChunks = "uploadVideoInChunksExternal";
export const completeAppTour = "completeAppTour";
export const downloadRecordedVideo = "downloadRecordedVideo";
export const getAvailableLimitsByOrganizationId = "get-available-limits";

export const UpdateParsedResume = "updateParsedResume";
export const GetParsedResumesDetailsWithPegination = "getParsedResumesDetailsWithPegination";
export const BulkInsertParsedResumes = "bulkInsertParsedResumes";
export const GetCandidateSummaryByCandidateId = "getParsedResumeByCandidateId";

export const GetOfferProposalFilesByCandidateId = "getOfferProposalFilesByCandidateId";
export const UploadOfferProposalFile = "uploadOfferProposalFiles";
export const DeleteOfferProposalFile = "deleteOfferProposalFile";
export const GetOfferProposalPreview = "getOfferProposalPreview";
export const ReplaceOfferProposalFile = "replaceOfferProposalFile";

export const GetVideoAnalysisResult = "getVideoAnalysisResult";
export const downloadViolationsFolder = "downloadViolationsFolder";
export const GetRequirementQuestionBank = "randomQuestionsListExternal";